import React from "react";
import {
    FormControlLabel,
    Checkbox as MUICheckbox,
    CheckboxProps,
} from "@material-ui/core";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: flex;
  margin-bottom: 5px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;
  /* identical to box height, or 183% */

  letter-spacing: -0.01em;

  color: #1e2029;

  /* Inside Auto Layout */
`;

function Checkbox({
                      inputLabel,
                      wrapperStyle,
                      controlStyle,
                      error,
                      label,
                      ...rest
                  }: ICheckbox) {
    return (
        <Wrapper style={wrapperStyle}>
            {inputLabel && <Label htmlFor={"input-" + rest.name}>{inputLabel}</Label>}
            <FormControlLabel
                style={{
                    color: "rgba(102,102,102,0.8)",
                    fontSize: "12px",
                    ...controlStyle,
                }}
                control={
                    <MUICheckbox id={"input-" + rest.name} {...rest} color="primary" />
                }
                label={label}
            />
            {error && <span style={{ color: "red" }}>{error}</span>}
        </Wrapper>
    );
}

export interface ICheckbox extends CheckboxProps {
    inputLabel?: string;
    label?: string;
    error?: string | number;
    wrapperStyle?: React.CSSProperties;
    controlStyle?: React.CSSProperties;
}

export default Checkbox;
